module.exports = __webpack_public_path__ + "img/everyone_keywords.c7ebfcdb.svg";